import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  parent: {
	    height: '100%',
	    width: '100%',
	    overflow: 'hidden',
	    position: 'relative'
  },
  child: {
	    position: 'absolute',
	    top: 0,
	    bottom: 0,
	    left: 0,
	    right: -17,
	    overflowY: 'scroll',
	    overflowX: 'hidden'
  }
}));

const SlimScroll = ({ children }) => {
  const classes = useStyles();

  return (
    <div className={classes.parent}>
      <div className={classes.child}>
        { children }
      </div>
    </div>
  );
}

export default SlimScroll;
